module.exports = __webpack_public_path__ + "img/document-icon.c4dd93df.svg";